import type { TFunction } from 'i18next';

import type { IRaisersEdgeSyncSummary } from '@feathr/blackbox';
import type { IIntegrationUIStat } from '@feathr/components';
import {
  getCrmSyncSummaryStats,
  getHeaderLastSyncedAt as getCrmHeaderLastSyncedAt,
} from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmSyncSummary.utils';

export { UNAVAILABLE_VALUE } from '@feathr/extender/App/Settings/Account/CrmIntegrationPage/crmSyncSummary.utils';

/** `null` means the request failed, so every value is unavailable. */
export type TRaisersEdgeSyncSummaryResult = IRaisersEdgeSyncSummary | null;

/** The summary bar's stats, in display order. */
export function getSyncSummaryStats(
  summary: TRaisersEdgeSyncSummaryResult,
  t: TFunction,
): IIntegrationUIStat[] {
  return getCrmSyncSummaryStats(
    summary,
    { key: 'constituents_synced', label: t('Constituents synced') },
    t,
  );
}

/**
 * The header's last sync time. The integration's own `date_last_down_synced` is never written for
 * Raiser's Edge, so prefer the summary once it has a value.
 */
export function getHeaderLastSyncedAt(
  summary: TRaisersEdgeSyncSummaryResult | undefined,
  fallback: string | undefined,
): string | null {
  return getCrmHeaderLastSyncedAt(summary, fallback);
}
